<template>
    <div />
</template>

<script>
    import { validationMixin } from 'vuelidate';
    import { required, maxLength } from "vuelidate/lib/validators";
    import { store } from "./store.js";
    export default {
        name: 'ValidationHelper',
        mixins: [validationMixin],
        data() {
            return {
                storeState: store.state,
            }
        },
        mounted() {
            store.setValidation(this.$v);
        },
        computed: {
            rules() {
                if (this.validationRules)
                    return this.validationRules[this.storeState.currentTab] ? this.validationRules[this.storeState.currentTab] : {}
                else
                    return {};
            },
        },
        methods: {
            hasError(fieldName) {
                return (fieldName in this.$v.formData) && (this.$v.formData[fieldName].$error)
            }
        },
        validations() {
            return {
                formData: this.rules,
                registrations: {
                    $each: {
                        registrationNumber:
                        {
                            required,
                            maxLength: maxLength(10)
                        },
                        file: {
                            required,
                            fileSizeValidation(value, itemArr) {
                                debugger;

                                if (value === undefined || value === null) {
                                    return true;
                                }
                                let file = value;
                                return (file.size < 10485760);
                            }
                        }
                    }
                }
            };
        }
    }
</script>